import { Stack, Box, Skeleton } from '@mui/material'

const ClientSkeleton = () => (
  <Stack gap={2} direction="column">
    <Box>
      <Skeleton variant="text" height={30} width="20%" />
      <Skeleton variant="rectangular" height={40} />
    </Box>

    <Box>
      <Skeleton variant="text" height={30} width="20%" />
      <Skeleton variant="rectangular" height={40} />
    </Box>

    <Box>
      <Skeleton variant="text" height={30} width="20%" />
      <Skeleton variant="rectangular" height={40} />
    </Box>

    <Box>
      <Skeleton variant="text" height={30} width="20%" />
      <Skeleton variant="rectangular" height={40} />
    </Box>

    <Box>
      <Skeleton variant="text" height={30} width="20%" />
      <Skeleton variant="rectangular" height={40} />
    </Box>

    <Box marginTop={2}>
      <Skeleton variant="rectangular" height={40} />
    </Box>
  </Stack>
)

export default ClientSkeleton
